module.exports = __webpack_public_path__ + "img/block-4.c92b3451.png";